// extracted by mini-css-extract-plugin
export var acitonButtons = "_bn-0";
export var additionalIcon = "_bn-f";
export var block = "_bn-1";
export var blockContent = "_bn-7";
export var blockDescription = "_bn-8";
export var blockIcon = "_bn-9";
export var blockTitle = "_bn-6";
export var border = "_bn-a";
export var center = "_bn-l";
export var edge = "_bn-b";
export var edgeLabel = "_bn-c";
export var edgePath = "_bn-d";
export var error = "_bn-e";
export var flowchart = "_bn-g";
export var flowchartContent = "_bn-h";
export var highlighted = "_bn-3";
export var hover = "_bn-4";
export var icon = "_bn-i";
export var left = "_bn-m";
export var navButton = "_bn-j";
export var navButtons = "_bn-k";
export var right = "_bn-n";
export var selected = "_bn-2";
export var small = "_bn-5";